<template>
    <div class="land-gallery">
        <div class="container">
            <div class="land-section-title" v-if="salesCardPage != null">
                <h2>{{salesCardPage.land_site_section_titles.gallery}}</h2>
                <a href="#" class="link-video" v-if="projectNameG == 'aqualina' && !VideoInit" @click.prevent="VideoInit = true">Видео</a>
                <a href="#" class="link-video" v-if="projectNameG == 'aqualina' && VideoInit" @click.prevent="VideoInit = false">Назад</a>
            </div>
            <videoSection v-if="VideoInit"></videoSection>
            <div class="land-gallery-items" v-if="!VideoInit">
                <div class="item-img" v-for="(item, index) in salesCard.project_land_site.gallery_images" :key="index" @click="indexActivve = index">
                    <svg-icon icon-class="resize-gal" className="icon-resize-gal"/>
                    <img :src="item" alt="">
                </div>
            </div>
            <div class="land-gallery-carousel-mobile"  v-if="!VideoInit">
                <swiper :options="swiperOptionGallery" ref="LandSalesgalleryCarousel" id="landGalleryCarousel">
                    <swiper-slide v-for="(slide, index) in salesCard.project_land_site.gallery_images" :key="index">
                        <div class="pic" :style="'background-image: url(' +  slide + ')'"></div>
                        <!-- <div class="promo-set"></div> -->
                    </swiper-slide>
                </swiper>
                <div class="swiper-controls land-gallery-carousel-navigation-mobile">
                    <div class="land-gal-prev-slide slider-btn"><svg-icon icon-class="left-arrow" className="icon icon-left-arrow"/></div>
                    <div class="land-gal-next-slide slider-btn"><svg-icon icon-class="right-arrow" className="icon icon-right-arrow"/></div>
                </div>
            </div>
        </div>
        <galleryLand :images="salesCard.project_land_site.gallery_images" :index="indexActivve" @close="indexActivve = null" class="lobbi-modal-biggest" @onopen="openGalModal" @onclosed="closeGalModal"></galleryLand>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import VueGallery from 'vue-gallery';
    import videoSection from '@/components/sales-land-partials/land-video.vue'
    export default {
        name: 'sale-land-gallery',
        components: {
            videoSection,
            'galleryLand': VueGallery,
        },
        data () {
            return {
                projectNameG: window.host,
                indexActivve: null,
                VideoInit:  false,
                swiperOptionGallery: {
                    speed: 800,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    loop: true,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '.land-gal-next-slide',
                        prevEl: '.land-gal-prev-slide',
                    }
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
            openGalModal() {
                document.getElementById('land-gallery').classList.add('openGallery');
                document.getElementById('landNav').classList.add('notvisibleSalesLand');

                document.getElementById('header').classList.add('notvisibleSalesLand');
                document.getElementById('footer').classList.add('notvisibleSalesLand');
                document.getElementById('banerTopHorizont').classList.add('notvisibleSalesLand');
            },
            closeGalModal() {
                document.getElementById('land-gallery').classList.remove('openGallery');
                document.getElementById('landNav').classList.remove('notvisibleSalesLand');

                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
                document.getElementById('banerTopHorizont').classList.remove('notvisibleSalesLand');
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-gallery.scss';
     @import '@/styles/respond/sales/sales-land-partials/land-gallery-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>